import { FormControl } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect from 'react-select';
import { Label } from './TextField';
import styles from './Inputs.module.css';
import DisplayErrorMessages from './DisplayErrorMessages';

const customStyles = (error) => ({
  option: (provided, { isSelected, isFocused }) => {
    const getBackgroundColor = () => {
      if (isSelected) return 'black';
      if (isFocused) return '#e5e5e5';
      return 'white';
    };

    return {
      ...provided,
      backgroundColor: getBackgroundColor(),
      color: isSelected ? 'white' : 'black',
      ':active': 'black',
      lineHeight: '24px',
      fontSize: '14px',
      letterSpacing: '1px',
    };
  },
  control: (base, state) => ({
    ...base,
    minHeight: '40px',
    boxShadow: state.isFocused ? 0 : 0,
    borderColor: error ? 'red' : base.borderColor,
    '&:hover': {
      borderColor: error ? 'red' : base.borderColor,
    },
  }),
});

function SelectInput(props) {
  const {
    formData,
    inputName,
    error,
    label,
    options,
    required = false,
    onChange = () => {},
    multiple = false,
    viewMode = false,
    errorText = null,
    disabled = false,
    testId = inputName,
  } = props;

  if (!viewMode) {
    return (
      <FormControl
        variant="standard"
        component="fieldset"
        required={required}
        style={{ marginBottom: '10px' }}
      >
        <Label label={label} required={required} error={error} />
        <ReactSelect
          isDisabled={disabled}
          onChange={(e) => {
            if (multiple) {
              onChange(
                inputName,
                e.map((option) => option.value),
              );
            } else {
              onChange(inputName, e ? e.value : e);
            }
          }}
          options={options}
          styles={customStyles(error)}
          value={
            multiple
              ? options.filter((option) =>
                  formData[inputName].includes(option.value),
                )
              : options.find((option) => option.value === formData[inputName])
          }
          isMulti={multiple}
          isClearable
          err
          inputId={testId}
          theme={(theme) => ({
            ...theme,
            borderRadius: '4px',
            colors: {
              ...theme.colors,
              primary: 'black',
            },
            '&:focus': {
              borderColor: 'none',
            },
          })}
        />
        <DisplayErrorMessages error={error} errorText={errorText} />
      </FormControl>
    );
  }
  return (
    <div className={styles.twoColumnLayout}>
      {label !== '' && <div className={styles.labelColumn}>{label}</div>}
      <div className={styles.valueColumn}>
        {multiple ? (
          formData[inputName].map((value) => {
            const option = options.find((opt) => opt.value === value);
            return (
              <div key={value} className={styles.tag}>
                {option && option.label}
              </div>
            );
          })
        ) : (
          <div className={styles.tag}>
            {options.find((opt) => opt.value === formData[inputName])?.label ||
              'N/A'}
          </div>
        )}
      </div>
    </div>
  );
}

SelectInput.propTypes = {
  formData: PropTypes.shape({}).isRequired,
  inputName: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  errorText: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  required: PropTypes.bool,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  viewMode: PropTypes.bool,
  disabled: PropTypes.bool,
  testId: PropTypes.string,
};

export default SelectInput;
